export default __webpack_public_path__ + "static/open-sans-latin-400-normal-36a546a98dbdb166cdce9a4f41078c3b.woff2";